function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import colors from "/styles/colors";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import CheckmarkIcon from "/static/svg/icons/checkmark2.svg";
import CollaborationWithComponent from "../../collaboration-with/collaboration-with-component";
import YoutubeCtaComponent from "/components/core/one-pager/youtube-cta/youtube-cta-component";
import componentStyles from "./text-part-component.scss";
class TextPartComponent extends PureComponent {
    getTitleLineStyle() {
        const { titleLinesFontSize, color } = this.props;
        return {
            color: colors[color],
            fontSize: titleLinesFontSize
        };
    }
    render() {
        const { titleLines, subtitleLines, bullets, color, signupForm, collaborationWith, popupVideo } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "text-part-component",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: `jsx-${componentStyles.__hash}` + " " + "title-lines-wrapper",
                    children: titleLines.map((line, index)=>/*#__PURE__*/ _jsx("span", {
                            dangerouslySetInnerHTML: {
                                __html: line
                            },
                            style: this.getTitleLineStyle(),
                            className: `jsx-${componentStyles.__hash}` + " " + "title-line"
                        }, index))
                }),
                /*#__PURE__*/ _jsx("h3", {
                    className: `jsx-${componentStyles.__hash}` + " " + "subtitle-lines-wrapper",
                    children: subtitleLines.map((line, index)=>/*#__PURE__*/ _jsx("span", {
                            dangerouslySetInnerHTML: {
                                __html: line
                            },
                            style: {
                                color: colors[color]
                            },
                            className: `jsx-${componentStyles.__hash}` + " " + "subtitle-line"
                        }, index))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "text-part-signup-form-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                        placeholder: signupForm.inputPlaceholder,
                        ctaText: signupForm.buttonText,
                        useCtaText: !!signupForm.buttonText,
                        buttonColor: signupForm.buttonColor,
                        focusOnLoad: signupForm.focusOnLoad,
                        className: "align-left"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "text-part-bullets",
                    children: bullets.map((line, index)=>/*#__PURE__*/ _jsxs("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + "bullet-line",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: `jsx-${componentStyles.__hash}` + " " + `bullet-line-icon-wrapper ${color}`,
                                    children: /*#__PURE__*/ _jsx(CheckmarkIcon, {})
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: line
                                    },
                                    style: {
                                        color: colors[color]
                                    },
                                    className: `jsx-${componentStyles.__hash}` + " " + "bullet-line-content"
                                })
                            ]
                        }, index))
                }),
                collaborationWith.show && /*#__PURE__*/ _jsx(CollaborationWithComponent, _object_spread({}, collaborationWith)),
                popupVideo.show && /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "second-cta-wrapper",
                    children: /*#__PURE__*/ _jsx(YoutubeCtaComponent, _object_spread({}, popupVideo))
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { TextPartComponent as default };
TextPartComponent.defaultProps = {
    titleLines: [
        "Project Management",
        "<b>is better when it's visual"
    ],
    subtitleLines: [
        "See what everyone on your team is working on in a single glance"
    ],
    bullets: [
        "Manage your projects & tasks with ease",
        "Plan visually on a timeline",
        "Centralize communication in one place"
    ],
    popupVideo: {}
};
